module.exports = __webpack_public_path__ + "static/media/old-middleware.6d8021b8.svg";